export const SET_USER_UNREAD_NOTIFICATIONS_COUNT = "SET_USER_UNREAD_NOTIFICATIONS_COUNT";
export const SET_IS_NOTIFICATIONS_POP_UP_VISIBLE = "SET_IS_NOTIFICATIONS_POP_UP_VISIBLE";
